var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-badge',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.ongoingTasks.length}},[_c('template',{slot:"badge"},[_c('v-icon',{staticClass:"rotate",attrs:{"dark":""}},[_vm._v(" mdi-autorenew ")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }